import { computed, ref } from 'vue';
import type { Ref } from 'vue'
import { useStore } from 'vuex';
import type { GetLanguagesResponse } from '@/types/openapi-ts';
import type { TranslateAction } from '@/types/core';

interface UseTranslateLanguagesParams {
  actions: Ref<TranslateAction[]>
}

export function useTranslateLanguages(params: UseTranslateLanguagesParams) {
  const store = useStore();
  const actions = params.actions || ref([]);
  const index = ref(0);

  const languages = computed<TranslateAction[]>(() => {
    const languages: GetLanguagesResponse['payload']  = store.state.misc.languages || [];
    return actions.value.map((el) => ({
      ...el,
      ...(languages.find((language) => language.code === el.language_code) || {}),
    }));
  });

  const selectedLanguages = computed(() => {
    return languages.value.map((language) => language.language_code);
  });

  const defaultLanguageIndex = computed(() => {
    return actions.value.findIndex((action) => action.is_default);
  });

  const handleSelectTab = (id: number) => {
    index.value = id;
  };

  return { selectedLanguages, defaultLanguageIndex, languages, handleSelectTab, actions, index };
}
